//站点系统
const stationSystemEn = {
  staSysLang: {
    请输入站点名称搜索: 'Please enter the station name',
    暂无数据: 'No data available',
    主机: 'Master',
    从机: 'Slave',
    未知: 'Unknown',
    请输入系统名称搜索: 'Please enter the system name',
    重置统计: 'Reset Statistics',
    远程控制: 'Remote control',
    能量管理: 'Energy management',
    当前站点系统: 'The current site system is ',
    已离线: 'offline',
    最后数据时间: 'Last data time',
    实时数据: 'Real time data',
    今日充电量: 'Charging data/Today',
    今日放电量: 'Discharge data/Today',
    累计充电量: 'Accumulated charge',
    累计放电量: 'Cumulative discharge',
    电池堆: 'Battery stack  ',
    告警状态: 'Alarm status',
    表示当前站点系统的设备告警状态告警内容为运维处理内容: 'Indicates the device alarm status of the current site system. The alarm content is O&M processing content.',
    进入设备监控: 'Enter device monitoring',
    名称: 'Name',
    状态: 'State',
    离线: 'Offline',
    告警: 'Give an alarm',
    正常: 'Normal',
    禁止放电: 'Prohibit discharge',
    取消: 'Cancel',
    确定: 'Confirm',
    重置统计: 'Reset Statistics',
    开始时间: 'Start time',
    选择日期时间: 'Select date time',
    时区: 'Time zone',
    请选择时区偏移: 'Please select a time zone offset!',
    请选择时间: 'Please select a time!'
  },
  energyManage: {
    //能量管理
    站点系统: 'Site System',
    能量管理: 'Energy management',
    远程控制: 'Remote control',
    本地控制: 'Local control',
    指EMS禁止本地控制: 'Local control is prohibited by the EMS.',
    指EMS禁止远程控制: 'Remote control is prohibited by the EMS.',
    调试方式: 'Debug mode',
    仅支持在本地屏进行控制模式变更: 'You can change the control mode only on the "Local screen".',
    智慧控制: 'Intelligent control',
    手动能量控制: 'Manual energy control',
    能量控制: 'Energy control',
    BMS并网控制: 'BMS grid connection control',
    防过载: 'Anti overload',
    防逆流: 'Anti-reflux',
    余量功率: 'Residual power',
    手动控制: 'Manual',
    二级保护: 'Secondary protection'
  },

  //智慧控制--智慧策略
  energyCommand: {
    能量控制参数由平台根据智慧能量管理算法生成请确保系统额定容量与额定功率数值真实准确:
      'The energy control parameters are generated by the platform according to the intelligent energy management algorithm. Please ensure that the values of "rated capacity" and "rated power" of the system are true and accurate.',
    智慧策略: 'Intelligent strategy',
    使用中: 'In use',
    待机中: ' Standing by',
    停用中: 'Out of use',
    时区: 'Time zone',
    额定容量: 'Rated capacity',
    额定功率: 'Rated power',
    启用: 'Enable',
    当前策略: 'Current strategy',
    历史策略: 'Historical strategy',
    日期: 'Date',
    选择日期: 'Please select a date',
    人工: 'artificial',
    通过智慧算法生成: 'Generated by smart algorithms',
    查看详情: 'Detail',
    充电: 'Charging',
    放电: 'Discharging',
    待机: 'Standby',
    计划功率: 'Planned power',
    时间: 'Time',
    当前暂无策略: 'There is currently no strategy',

    //智慧控制--人工策略
    开始时间: 'Start time',
    选择时间: 'Selection time',
    结束时间: 'Finish time',
    执行储能控制类别: 'Execute energy storage control category',
    请输入功率: 'Please input power',
    暂无数据: 'No data available',
    提示: 'Hint',
    新增: 'Newly increased',
    请确认是否启用智慧控制启用后将会停止人工控制策略进入待机状态直到新的智慧控制策略下发:
      'Please confirm whether the smart control is enabled or not. After it is enabled, the manual control strategy will be stopped and the standby state will be entered until the new smart control strategy is issued!',
    请确认是否启用人工控制启用后智慧控制策略将会被停用: 'Please confirm whether to enable manual control, the smart control strategy will be deactivated!',
    否: 'No',
    是: 'Yes',

    请选择开始时间: 'Please select a start time',
    开始时间不可与结束时间相同: 'The start time cannot be the same as the end time',
    选择结束时间: 'Please select a end time',
    结束时间不可与开始时间相同: 'The end time cannot be the same as the start time',
    请选择类别: 'Please select a category',
    请输入计划功率: 'Please enter the planned power',
    时间段存在冲突请重新配置: 'Time range conflict, please reconfigure!',
    请确认是否应用能量控制参数: 'Please confirm whether to apply energy control parameters!',
    应用: 'Application',
    取消: 'Cancel'
  },

  powerControl: {
    //手动能量控制
    设置参数后需点击应用按钮方可执行无充电或放电操作的时间段将执行待机操作:
      'After setting the parameters, you need to click the "Apply" button to execute. During the time period without charging or discharging operation, standby operation will be executed!',
    开始时间: 'Start time',
    选择时间: 'Selection time',
    结束时间: 'Finish time',
    执行储能控制类别: 'Execute energy storage control category',
    充电: 'Charging',
    放电: 'Discharging',
    待机: 'Standby',
    计划功率: 'Planned power',
    请输入功率: 'Please input power',
    计划SOC: 'Planned SOC',
    请输入计划SOC: 'Please input SOC',
    暂无数据: 'No data available',
    新增: 'Newly increased',
    取消: 'Cancel',
    应用: 'Application',
    请选择开始时间: 'Please select a start time',
    开始时间不可与结束时间相同: 'The start time cannot be the same as the end time',
    请选择结束时间: 'Please select a end time',
    结束时间不可与开始时间相同: 'The end time cannot be the same as the start time',
    请选择类别: 'Please select a category',
    请输入计划功率: 'Please enter the planned power',
    时间段存在冲突请重新配置: 'Time range conflict, please reconfigure!',
    请确认是否应用能量控制参数: 'Please confirm whether to apply energy control parameters!',
    当前页面参数已调整请确认是否要放弃修改: 'The current page parameters have been adjusted. Are you sure you want to discard the modifications? ',
    是否放弃修改: 'Do you want to abandon the modification?',
    放弃: 'Discard changes'
  },
  powerControlHy: {
    //华友能量控制
    能量控制策略应用月份需满足12个月点击页面底部应用按钮下发后方可执行:
      'The application month of the energy control strategy needs to be 12 months. It can only be executed after clicking the "Apply" button at the bottom of the page and issuing it.',
    已满12个月无法新建策略: 'It has been 12 months and cannot be used.',
    新建策略: 'New policy',
    应用月份: 'Application Month',
    操作人: 'Operator',
    操作: 'Operation',
    查看: 'Examine',
    编辑: 'Edit',
    已满12个月无法引用: 'It has been 12 months and cannot be used.',
    请确认是否删除该策略: 'Please confirm whether to delete the policy?',
    删除: 'Delete',
    暂无数据: 'No data available',
    取消: 'Cancel',
    应用月份未满12个月请新建策略: 'The application month is less than 12 months, please create a new policy!',
    已满12个月可点击应用按钮下发执行: 'It has been 12 months and can be executed by clicking the "Apply" button!',
    应用: 'Application',
    查看详情: 'Detail',
    月: '',
    开始时间: 'Start time',
    结束时间: 'Finish time',
    对应时段: 'Corresponding time period',
    最大充电功率: 'Maximum charging power ',
    最大放电功率: 'Maximum discharge power ',
    尖: 'Tip',
    峰: 'Peak',
    平: 'Flat',
    谷: 'Valley',
    确定: 'Confirm',

    站点系统: 'Site System',
    编辑策略: 'Edit Policy',
    应用月份选择: 'Application Month Selection',
    月份支持一次选择多个选择完成后在下方填写所选月份的能量控制参数: 'Multiple months can be selected at once. After selection, fill in the energy control parameters for the selected month below.',
    该月份在其他策略中已选择: 'This month has been selected in other strategies.',
    月份: 'Month',
    能量控制参数: 'Energy control parameters',
    为选择的月份设置参数后需点击确定按钮: 'After setting parameters for the selected month, click the "OK" button.',
    开始时间: 'Start time',
    结束时间: 'Finish time',
    请选择: 'Please select',
    请输入: 'Please enter',
    暂无数据: 'No data available',
    新增: 'Newly increased',
    确定: 'Confirm',
    一月: '1',
    二月: '2',
    三月: '3',
    四月: '4',
    五月: '5',
    六月: '6',
    七月: '7',
    八月: '8',
    九月: '9',
    十月: '10',
    十一月: '11',
    十二月: '12',
    请选择时间: 'Please select a time!',
    请选择时间段类型: 'Please select a time period type!',
    请输入最大充电功率: 'Please enter the maximum charging power!',
    请输入最大放电功率: 'Please enter the maximum discharge power!',
    当前页面参数已调整请确认是否要放弃修改: 'The current page parameters have been adjusted. Are you sure you want to discard the modifications? ',
    是否放弃修改: 'Do you want to abandon the modification?',
    放弃: 'Discard changes',
    请选择配置月份: 'Please select the configuration month!',
    请配置能量控制参数: 'Please configure energy control parameters!'
  },

  //防过载
  preventOverload: {
    设置参数时请按照禁充阈值大于限充阈值大于启动阈值填写: 'When setting parameters, please fill in according to "Prohibit Charging Threshold>Limit Charging Threshold>Start Threshold"! ',
    防过载设置: 'Anti overload setting',
    防过载功能: 'Anti overload function',
    使能: 'Enable',
    禁能: 'Forbidden energy',
    禁充阈值: 'Forbidden charging threshold',
    限充阈值: 'Charge limit threshold',
    启动阈值: 'Start threshold',
    请输入: 'Please enter',
    暂无数据: 'No data available',
    取消: 'Cancel',
    应用: 'Application',
    请输入限充阈值: 'Please enter the charge limit threshold',
    请输入启动阈值: 'Please enter a start threshold',
    请输入禁充阈值: 'Please enter the prohibited charging threshold',
    '请确认是否启用防过载功能？': 'Please confirm if the anti overload function is enabled?',
    提示: 'Hint',
    否: 'No',
    是: 'Yes',
    '请确认是否禁用防过载功能？': 'Please confirm if the anti overload function is disabled?',
    请按照禁充阈值大于限充阈值大于启动阈值填写: 'Please fill in according to "Prohibit Charging Threshold>Limit Charging Threshold>Start Threshold"! ',
    请确认是否应用防过载参数: 'Please confirm if the anti overload parameter is applied!',
    当前页面参数已调整请确认是否要放弃修改: 'The current page parameters have been adjusted. Are you sure you want to discard the modifications? ',
    是否放弃修改: 'Do you want to abandon the modification?',
    放弃: 'Discard changes'
  },

  //防逆流
  preventReflux: {
    设置参数时请按照启动阈值大于限放阈值大于禁放阈值填写: 'When setting parameters, please fill in according to "Start threshold>Limit threshold>Prohibit threshold"!',
    防逆流设置: ' Anti backflow setting ',
    防逆流功能: 'Anti reflux function',
    使能: 'Enable',
    禁能: 'Forbidden energy',
    启动阈值: 'Start threshold',
    限放阈值: ' Limiting discharge threshold ',
    禁放阈值: ' Prohibit discharge threshold ',
    请输入: 'Please enter',
    暂无数据: 'No data available',
    取消: 'Cancel',
    应用: 'Application',
    请输入启动阈值: 'Please enter a start threshold',
    请输入限放阈值: 'Please enter the limit discharge threshold ',
    请输入禁放阈值: 'Please enter the threshold for prohibiting discharge ',
    '请确认是否启用防逆流功能？': 'Please confirm if the anti reflux function is enabled?',
    提示: 'Hint',
    否: 'No',
    是: 'Yes',
    '请确认是否禁用防逆流功能？': 'Please confirm if the anti reflux function is disabled?',
    请按照启动阈值大于限放阈值大于禁放阈值填写: 'Please fill in according to "Start threshold>Limit threshold>Prohibit threshold"!',
    请确认是否应用防逆流参数: 'Please confirm whether to apply anti backflow parameters!',
    当前页面参数已调整请确认是否要放弃修改: 'The current page parameters have been adjusted. Are you sure you want to discard the modifications? ',
    是否放弃修改: 'Do you want to abandon the modification?',
    放弃: 'Discard changes'
  },
  //余量功率
  marginPower: {
    余量功率设置时请将参数控制在变压器容量的百分之五至百分之二十之间: 'When setting the residual power, please control the parameters between 5% and 20% of the transformer capacity.',
    余量功率设置: 'Margin power setting',
    变压器容量: 'Transformer capacity',
    变压器信息: 'Transformer information',
    充电余量: 'Charging margin',
    数值范围: 'Numeric range',
    放电余量: 'Discharge margin',
    EMS使能: 'EMS Enable',
    使能: 'Enable',
    禁能: 'Forbidden energy',
    暂无数据: 'No data available',
    取消: 'Cancel',
    应用: 'Application',
    数字范围: 'Number range',
    整数: 'Integer',
    请选择: 'Please select',
    请输入充电余量: 'Please enter the charging allowance',
    请输入放电余量: 'Please input the discharge margin',
    提示: 'Hint',
    请确认是否应用余量功率参数: 'Please confirm whether to apply the margin power parameter!',
    当前页面参数已调整请确认是否要放弃修改: 'The current page parameters have been adjusted. Are you sure you want to discard the modifications? ',
    是否放弃修改: 'Do you want to abandon the modification?',
    放弃: 'Discard changes'
  },

  //手动控制
  manualControl: {
    并网控制: 'Grid-connected control',
    PCS控制: 'PCS control',
    控制设置: 'Control settings',
    当前状态: 'Current state',
    控制模式: 'Control model',
    手动: 'Manual operation',
    控制类别: 'Control class',
    充电: 'Charging',
    放电: 'Discharging',
    待机: 'Standby',
    计划功率: 'Planned power',
    自动: 'Automatic',
    请输入: 'Please enter',
    控制参数: 'Control parameters',
    跟随能量控制: 'Follow energy control',
    调整控制模式: 'Adjusting the control mode',
    跟随能量控制自动配置: 'Follow the energy control automatic configuration',
    应用: 'Application',
    '下发“并网/离网”指令后，请“开启/断开”市电网电路！': 'After issuing the "grid connection/disconnection" command, please "turn on/off" the municipal power grid circuit!',
    离网运行: 'Off grid operation',
    取消: 'Cancel',
    确定: 'Confirm',
    请输入计划功率: 'Please enter the planned power',
    提示: 'Hint',
    '请确认是否下发PCS运行/停机指令！': 'Please confirm whether to issue PCS operation/shutdown instructions!',
    PCS运行: 'PCS operation',
    PCS停机: 'PCS shutdown',
    请确认是否应用: 'Please confirm whether to apply?'
  },
  //二级保护
  secondaryProtection: {
    二级保护设置: 'Secondary protection settings',
    当前参数: 'Current parameters',
    SOC上限: 'SOC upper limit',
    SOC下限: 'SOC Lower limit',
    放电截止电压: 'Discharge Cut-off Voltage',
    充电截止电压: 'Charging cutoff voltage',
    过放释放电压: 'Overdischarge release voltage',
    过充释放电压: 'Overcharge release voltage',
    二级保护参数设置: 'Secondary protection parameter settings',
    请输入: 'Please enter',
    应用: 'Application',
    请输入SOC上限: 'Please enter the SOC upper limit',
    请输入SOC下限: 'Please enter the SOC Lower limit',
    请输入放电截止电压: 'Please input the discharge cut-off voltage',
    请输入充电截止电压: 'Please input the charging cut-off voltage',
    请输入过放释放电压: 'Please input the overvoltage release voltage',
    请输入过充释放电压: 'Please input overcharge release voltage',
    小数点后不允许超过3位: 'No more than 3 digits are allowed after the decimal point',
    '请确认是否应用二级保护参数？': 'Please confirm if secondary protection parameters are applied?',
    提示: 'Hint',
    取消: 'Cancel'
  }
}
export default stationSystemEn
